import { render } from "./RecursoPulpo.vue?vue&type=template&id=578e0fa0&scoped=true"
import script from "./RecursoPulpo.vue?vue&type=script&lang=js"
export * from "./RecursoPulpo.vue?vue&type=script&lang=js"

import "./RecursoPulpo.vue?vue&type=style&index=0&id=578e0fa0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578e0fa0"]])

export default __exports__